import { ASSET } from '../elements/assets'
import { LINK_FIELD } from '../elements/link'

export const GROUPED_FEATURES = `
...on groupedFeatures_Entry {
  id
  typeHandle

  backgroundColor
  heading {
    html
  }
  description

  groupedFeaturesContent {
    ... on groupedFeaturesContent_Entry {
      features {
        ... on feature_Entry {
          id
          subheading
          heading {
            html
          }
          description {
            html
          }
          iconField {
            url
            title
          }
          ${ ASSET }
          ${ LINK_FIELD }
        }
      }
    }
  }
  
}
`